<h2 class="panel-gruppe-tittel" data-testid="dashboardstatus-radtittel">
  {{ 'Du skal signere'|translate }}
  <button mat-icon-button type="button" (click)="lukk()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<div class="panel-skrollkontainer" [style.max-height.px]="maksPopupHoeyde() - 40"><!-- -40 for å ta høyde for høyden til overliggende h2 -->
  <section data-testid="duskalsignere">
    @if (dokumenterBrukerIkkeHarSignert().moeter.length === 0
    && dokumenterBrukerIkkeHarSignert().saksdokumenter.length === 0
    && dokumenterBrukerIkkeHarSignert().arkivdokumenter.length === 0) {
      <div class="ingen-dokumenter">
        {{ 'Du har signert alle dokumentene'|translate }}
        <mat-icon>celebration</mat-icon>
      </div>
    }

    @if (dokumenterBrukerIkkeHarSignert().moeter.length > 0) {
      <section data-testid="dokumentgruppe">
        <h3 data-testid="gruppetittel">{{ 'Protokolldokumenter'|translate }}</h3>
        @for (moete of dokumenterBrukerIkkeHarSignert().moeter; track moete.tilSignering.id) {
          <div (click)="gaaTilProtokoll(moete.tilSignering)" class="rad egne" data-testid="dokument">
            <mat-icon fontSet="lederplan-ikon-dokument" class="panel-entitet-ikon mat-icon--lederplan-ikon"/>
            <a class="tittel">
              <span data-testid="dokumentnavn">{{ moete.tilSignering.tittel }} {{ moete.tilSignering.nummer }}, {{ moete.tilSignering.dato.start | zoneddatetimeSomPlaindate|plaindate }}</span>,
              {{ gruppeinfo(moete.tilSignering.eiendeGruppeId) }}
            </a>
            <span class="svar-knapp">
              <button mat-stroked-button color="primary" type="button" (click)="gaaTilProtokoll(moete.tilSignering)">
                {{ "Gå til protokoll" | translate }}
              </button>
            </span>
          </div>
        }
      </section>
    }

    @if (dokumenterBrukerIkkeHarSignert().saksdokumenter.length > 0) {
      <section data-testid="dokumentgruppe">
        <h3 data-testid="gruppetittel">{{ 'Saksdokumenter'|translate }}</h3>
        <ng-container *ngTemplateOutlet="dokumenterTilSigneringAvBrukerFragment; context: {dokumenter: dokumenterBrukerIkkeHarSignert().saksdokumenter}"/>
      </section>
    }

    @if (dokumenterBrukerIkkeHarSignert().arkivdokumenter.length > 0) {
      <section data-testid="dokumentgruppe">
        <h3 data-testid="gruppetittel">{{ 'Biblioteksdokumenter'|translate }}</h3>
        <ng-container *ngTemplateOutlet="dokumenterTilSigneringAvBrukerFragment; context: {dokumenter: dokumenterBrukerIkkeHarSignert().arkivdokumenter}"/>
      </section>
    }
  </section>

  @if (harSkrivetilgang()) {
    <section data-testid="andreskalsignere">
      <h2 class="panel-gruppe-tittel" data-testid="dashboardstatus-radtittel">{{ 'Andre skal signere'|translate }}</h2>

      @if (dokumenterAndreSkalSignere().moeter.length === 0
      && dokumenterAndreSkalSignere().saksdokumenter.length === 0
      && dokumenterAndreSkalSignere().arkivdokumenter.length === 0) {
        <div class="ingen-dokumenter">
          {{ 'Alle andre har signert dokumentene'|translate }}
          <mat-icon>celebration</mat-icon>
        </div>
      }

      @if (dokumenterAndreSkalSignere().moeter.length > 0) {
        <section data-testid="dokumentgruppe">
          <h3 data-testid="gruppetittel">{{ 'Protokolldokumenter'|translate }}</h3>
          @for (moete of dokumenterAndreSkalSignere().moeter; track moete.tilSignering.id) {
            <div class="rad andres" data-testid="dokument">
              <mat-icon fontSet="lederplan-ikon-dokument" class="panel-entitet-ikon mat-icon--lederplan-ikon"/>
              <a (click)="gaaTilProtokoll(moete.tilSignering)" class="tittel">
                <span data-testid="dokumentnavn">{{ moete.tilSignering.tittel }} {{ moete.tilSignering.nummer }}, {{ moete.tilSignering.dato.start | zoneddatetimeSomPlaindate|plaindate }}</span>,
                {{ gruppeinfo(moete.tilSignering.eiendeGruppeId) }}
              </a>
              <div (click)="visEllerSkjulSignaturstatus(moete.tilSignering.id)" class="antall" data-testid="vis-skjul-signaturstatus-knapp">
                {{ '{antall} av {total} har signert'|translate:{antall: antallSomHarSignert(moete.signatarer), total: moete.signatarer.signatarer.length} }}
              </div>
              @if (viserSignaturstatusSignal(moete.tilSignering.id)()) {
                <!-- vi har ikke impl støtte for å avslutte signering (kun impl avbryt) for protokolldokument, derfor kalles signaturstatusFragment med dokumentversjon=null-->
                <ng-container *ngTemplateOutlet="signaturstatusFragment; context: {signatarer: moete.signatarer, dokumentId: moete.tilSignering.protokolldokumentId, dokumentversjon: null}"/>
              }
              <!--@if (viserAvsluttSigneringstips(moete.signatarer) && !viserSignaturstatusSignal(moete.tilSignering.id)()) {
                <ng-container *ngTemplateOutlet="avsluttSigneringTipsFragment; context: {signatarer: moete.signatarer, dokumentId: moete.tilSignering.protokolldokumentId}"/>
              }-->
            </div>
          }
        </section>
      }

      @if (dokumenterAndreSkalSignere().saksdokumenter.length > 0) {
        <section data-testid="dokumentgruppe">
          <h3 data-testid="gruppetittel">{{ 'Saksdokumenter'|translate }}</h3>
          <ng-container *ngTemplateOutlet="dokumenterTilSigneringAvAndreFragment; context: {dokumenter: dokumenterAndreSkalSignere().saksdokumenter}"/>
        </section>
      }

      @if (dokumenterAndreSkalSignere().arkivdokumenter.length > 0) {
        <section data-testid="dokumentgruppe">
          <h3 data-testid="gruppetittel" translate>{{ 'Biblioteksdokumenter'|translate }}</h3>
          <ng-container *ngTemplateOutlet="dokumenterTilSigneringAvAndreFragment; context: {dokumenter: dokumenterAndreSkalSignere().arkivdokumenter}"/>
        </section>
      }
    </section>
  }
</div>


<ng-template #dokumenterTilSigneringAvBrukerFragment [typetNgTemplate]="dokumenterTilSigneringFragmentKontekstType" let-dokumenter="dokumenter">
  @for (dokument of dokumenter; track dokument.tilSignering.id) {
    <div (click)="gaaTilDokumentForSignering(dokument.tilSignering)" class="rad egne" data-testid="dokument">
      <mat-icon fontSet="lederplan-ikon-dokument" class="panel-entitet-ikon mat-icon--lederplan-ikon"/>
      <a class="tittel">
        <span data-testid="dokumentnavn">{{ dokument.tilSignering.filnavn }}</span>,
        {{ gruppeinfo(dokument.tilSignering.gruppeId) }}
      </a>
      <span class="svar-knapp">
        <button mat-stroked-button color="primary" type="button" (click)="gaaTilDokumentForSignering(dokument.tilSignering)">
          {{ "Signer" | translate }}
        </button>
      </span>
    </div>
  }
</ng-template>

<ng-template #dokumenterTilSigneringAvAndreFragment [typetNgTemplate]="dokumenterTilSigneringFragmentKontekstType" let-dokumenter="dokumenter">
  @for (dokument of dokumenter; track dokument.tilSignering.id) {
    <div class="rad andres" data-testid="dokument">
      <mat-icon fontSet="lederplan-ikon-dokument" class="panel-entitet-ikon mat-icon--lederplan-ikon"/>
      <a class="tittel" (click)="gaaTilDokument(dokument.tilSignering)">
        <span data-testid="dokumentnavn">{{ dokument.tilSignering.filnavn }}</span>,
        {{ gruppeinfo(dokument.tilSignering.gruppeId) }}
      </a>
      <div (click)="visEllerSkjulSignaturstatus(dokument.tilSignering.id)" class="antall" data-testid="vis-skjul-signaturstatus-knapp">
        {{ '{antall} av {total} har signert'|translate:{antall: antallSomHarSignert(dokument.signatarer), total: dokument.signatarer.signatarer.length} }}
      </div>
      @if (viserSignaturstatusSignal(dokument.tilSignering.id)()) {
        <ng-container *ngTemplateOutlet="signaturstatusFragment; context: {signatarer: dokument.signatarer, dokumentId: dokument.tilSignering.dokumentId, dokumentversjon: dokument.tilSignering}"/>
      }
      @if (viserAvsluttSigneringstips(dokument) && !viserSignaturstatusSignal(dokument.tilSignering.id)()) {
        <ng-container *ngTemplateOutlet="avsluttSigneringTipsFragment; context: {signatarer: dokument.signatarer, dokumentversjon: dokument.tilSignering}"/>
      }
    </div>
  }
</ng-template>

<ng-template #signaturstatusFragment [typetNgTemplate]="signaturstatusFragmentKontekstType" let-signatarer="signatarer" let-dokumentId="dokumentId" let-dokumentversjon="dokumentversjon">
  <div class="signaturstatus" @fadeInn>
    <div class="signatarer" data-testid="signatarer">
      @for (signatar of signatarer.signatarer; track signatar.id) {
        <div class="signatar">
          <avatar [medlem]="signatar.medlem"></avatar>
          <div>
            <div data-testid="navn">{{ signatar.medlem.navn }}</div>
            @if (!signatar.harSignert) {
              <div class="påminnelse">{{ purringSendeOmAntallDager(signatarer) }}</div>
            }
          </div>
          @if (signatar.harSignert) {
            <div class="status" matTooltip="{{signeringsinformasjon(signatar)}}" data-testid="signaturstatus">
              {{ 'Signert'|translate }} {{ signatar.signaturinformasjon!.signertDato | zoneddatetimeSomPlaindate|plaindate }}
            </div>
          } @else {
            <div class="status" data-testid="signaturstatus">{{ 'Ikke signert'|translate }}</div>
          }
        </div>
      }
    </div>

    <div class="handlinger">
      <button mat-stroked-button type="button" (click)="sendPurring(dokumentId)" matTooltip="{{'Åpner dialog som lar deg sende påminnelse til de som ikke har signert'|translate}}">
        {{ 'Send påminnelse'|translate }}
      </button>
      @if (avsluttSigneringMulig(dokumentversjon)) {
        <button mat-stroked-button type="button" color="warn" (click)="avsluttSignering(dokumentversjon!)" matTooltip="{{'Åpner dialog som lar deg avslutte signeringsprosessen'|translate}}">
          {{ 'Avslutt signering'|translate }}
        </button>
      }
    </div>
  </div>
</ng-template>

<ng-template #avsluttSigneringTipsFragment [typetNgTemplate]="avsluttSigneringTipsFragmentKontekstType" let-signatarer="signatarer" let-dokumentversjon="dokumentversjon">
  <div class="avslutt-tips" @fadeInn>
    {{ 'Det er {antall} dager siden signering startet.'|translate:{antall: dagerSidenSendtTilSignering(signatarer)} }}
    <a (click)="avsluttSignering(dokumentversjon)" matTooltip="{{'Åpner dialog som lar deg avslutte signeringsprosessen'|translate}}">
      {{ 'Vil du avslutte signeringen?'|translate }}
    </a>
  </div>
</ng-template>
